export default __webpack_public_path__ + "static/media/recommend.6d148c01.jpg";